import { render, staticRenderFns } from "./BirthYear.vue?vue&type=template&id=2a0a4353&scoped=true&"
import script from "./BirthYear.vue?vue&type=script&lang=js&"
export * from "./BirthYear.vue?vue&type=script&lang=js&"
import style0 from "./BirthYear.vue?vue&type=style&index=0&id=2a0a4353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a4353",
  null
  
)

export default component.exports